<template>
  <div class="menuw">
    <div class="menu">
      <div class="menu1">
        <img src="../assets/image/logo.png"/>
      </div>
      <div class="menu2">
        <ul class="menu-container">
          <li v-for="(item,index) in menuList" :key="index">
            <router-link :class="{ulAsty:true,ulAstyActive:(route==item.route)}" :to="{ 'name': item.src}" @click.native="toLoginValide(item)">{{item.name}}</router-link>
            <div class="ul-child" v-if="item.child">
              <ul style="box-shadow:0 0 5px #00000020;">
                <li class="li-child" v-for="(item1,index1) in item.child" :key="index1">
                  <router-link :to="{}" @click.native="toLoginValide1(item,item1,index1)">
                    {{item1.name}}
                    </router-link
                  >
                </li>
              </ul>
            </div>

          </li>
        </ul>
      </div>
     <!-- <div class="menu2">
        <ul class="menu-container">
          <li v-for="(item,index) in menuList" :key="index">
            <router-link class="ulAsty" :to="{ 'name': item.src }">{{item.name}}</router-link>
            <ul class="ul-child" v-if="item.child">
              <li class="li-child" v-for="(item1,index1) in item.child" :key="index1">
                <router-link :to="{ 'name': item1.src }">{{item1.name}}</router-link
                >
              </li>
            </ul>
          </li>
        </ul>
      </div> -->
      <div style="flex: 0 0 1.5rem;position: relative;z-index: 10000;">
        <div class="menu3t" style="height: 1.125rem;" v-if="!zhShow">
          <!-- <img src="./image/play.png" style="width: 1rem;height: 1rem;"> -->
          <ul class="menu-container" style="padding-left: 0;">
            <li style="width:1.6375rem">
              <router-link class="ulAsty" :to="{ 'name': 'PersonInfo' }" style="display: flex;justify-content: center;align-items: center;">
                <img :src="userAllInfo.image" style="border-radius:50%;width: 0.625rem;height: 0.625rem;">
              </router-link>
              <ul class="ul-child">
                <li class="li-child" >
                  <router-link :to="{name:'PersonInfo'}">个人中心</router-link>
                </li>
                <!-- <li class="li-child">
                  <router-link  :to="{name:'Account'}">账号设置</router-link>
                </li> -->
                <li class="li-child">
                  <!-- <a href="/">退出登录</a> -->
                  <router-link :to="{}" @click.native="logout">退出登录</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <!-- <div class="menu3" style="justify-content: center;" v-if="zhShow">
          <div class="menu31" style="cursor:pointer" @click="toLogin(1)">注册</div>
          <div class="menu32" style="cursor:pointer;" @click="toLogin(2)">登录</div>
        </div> -->
      </div>
      <div class="menu4" style="position: relative;;z-index: 3000;height: 1.125rem;line-height: 1.125rem;">
        <i class="el-icon-search" style="cursor: pointer;" @click="tosearchShow"></i>
        <el-input placeholder="请输入你想搜索的关键词" v-model="searchName" style="position: absolute;top: 1.125rem;right: 0" v-if="searchShow">
            <el-button slot="append" @click="toSearch">搜索</el-button>
          </el-input>
      </div>
<!--      <div class="menu5">
        <el-select v-model="value" placeholder="请选择" popper-class="menuSelect" @change="change" ref="menuSelect">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
      </div> -->
    </div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  import {getMe} from '@/api/login.js'
  import {logout} from '@/api/login.js'
export default {
  name: "app",
  data() {
    return {
      route:'/',
      searchName:'',
      showMenu:true,
      searchShow:false,
      input3:'',
      zhShow:1,
      lang:'zh',
      src:'PersonInfo',
      src1:'Account',
      userAllInfo:{},
      menuList:[
        {id:1,name:'首页',src:'Index',child:[],route:'/'},
        {id:2,name:'场馆概况',src:'Overview',route:'/overview/overviewInfo',child:[
          {id:21,name:'场馆介绍',src:'Overview'},
          // {id:22,name:'机构设置',src:'Overview'},
          // {id:23,name:'大事记',src:'Overview'},
        ]},
        {id:3,name:'展览导航',src:'Navigation',route:'/navigation/navigationInfo',child:[
          {id:21,name:'临时展览',src:'Navigation',href:'#navigatepage1'},
          {id:22,name:'常设展览',src:'Navigation',href:'#navigatepage2'},
          {id:22,name:'特展回眸',src:'Navigation',href:'#navigatepage3'},
        ]},
        {id:4,name:'科普知识',src:'Knowledge',route:'/knowledge/knowList',child:[
          {id:21,name:'科技精粹',src:'Knowledge'},
          {id:22,name:'展项原理',src:'Knowledge'},
        ]},
        {id:5,name:'信息资讯',src:'Information',route:'/information/infoList',child:[]},
        {id:6,name:'服务咨询',src:'Consult',route:'/consult/consultInfo',child:[
          {id:21,name:'参观预约',src:'Consult'},
          // {id:22,name:'问卷调查',src:'Consult'},
          {id:21,name:'参观须知',src:'Consult'},
          {id:22,name:'服务设施',src:'Consult'},
          // {id:22,name:'留言板',src:'Consult'},
        ]},
        {id:9,name:'专题专栏',src:'PartyInfo',route:'/partyInfo/partyList',child:[]},
        // {id:7,name:'展教活动',src:'EduInform',route:'/eduActivity/eduInfo',child:[
        //   {id:21,name:'教育活动',src:'EduInform'},
        //   {id:22,name:'培训班',src:'EduActivity'},
        //   {id:21,name:'热门展项',src:'EduActivity'},

        // ]},
        //   {id:8,name:'青少年科教',src:'Teenager',route:'/teenager/teenagerInfo',child:[
        //   {id:21,name:'科技竞赛',src:'Teenager'},
        //   {id:22,name:'通知公告',src:'Teenager'},
        //   {id:21,name:'活动报道',src:'Teenager'},
        //   {id:22,name:'优秀作品展示',src:'Teenager'},
        //   {id:22,name:'资料下载',src:'Teenager'},
        // ]},
        //   {id:9,name:'流动科技馆',src:'Museum',route:'/museum/museumInfo',child:[
        //   {id:21,name:'流动科技馆简介',src:'Museum'},
        //   {id:22,name:'巡展申请',src:'Museum'},
        //   {id:21,name:'活动报道',src:'Museum'},
        // ]},
      ],
      options: [{
        value: '0',
        label: '中文'
      }, {
        value: '1',
        label: 'ENGLISH'
      },{
        value: '2',
        label: '日本語'
      },{
        value: '3',
        label: '한국어'
      }
      ],
      value: ''
    };
  },

  computed: {
      // menuList() {
      //     return [
      //   {id:1,name:this.$t("m['首页']"),src:'Home',child:[]},
      //   {id:2,name:this.$t("m['场馆概况']"),src:'Overview',child:[
      //     {id:21,name:this.$t("m['场馆介绍']"),src:'Overview'},
      //     {id:22,name:this.$t("m['机构设置']"),src:'Overview'},
      //     {id:23,name:this.$t("m['大事记']"),src:'Overview'},
      //   ]},
      //   {id:3,name:this.$t("m['展览导航']"),src:'Navigation',child:[
      //     {id:21,name:this.$t("m['临时展览']"),src:'Navigation'},
      //     {id:22,name:this.$t("m['常设展览']"),src:'Navigation'},
      //   ]},
      //   {id:4,name:this.$t("m['科普知识']"),src:'Knowledge',child:[
      //     {id:21,name:this.$t("m['科技精粹']"),src:'Knowledge'},
      //     {id:22,name:this.$t("m['展项原理']"),src:'Knowledge'},
      //   ]},
      //   {id:5,name:this.$t("m['信息资讯']"),src:'Information',child:[]},
      //   {id:6,name:this.$t("m['服务咨询']"),src:'Consult',child:[
      //     {id:21,name:this.$t("m['参观预约']"),src:'Consult'},
      //     {id:22,name:this.$t("m['问卷调查']"),src:'Consult'},
      //     {id:21,name:this.$t("m['参观须知']"),src:'Consult'},
      //     {id:22,name:this.$t("m['服务设施']"),src:'Consult'},
      //     {id:22,name:this.$t("m['留言板']"),src:'Consult'},
      //   ]},
      //   {id:7,name:this.$t("m['展教活动']"),src:'EduActivity',child:[
      //     {id:21,name:this.$t("m['教育活动']"),src:'EduActivity'},
      //     {id:22,name:this.$t("m['培训班']"),src:'EduActivity'},
      //     {id:21,name:this.$t("m['热门展项']"),src:'EduActivity'},

      //   ]},
      //   {id:8,name:this.$t("m['特效影院']"),src:'Cinema',child:[]},
      // ]
      // }
  },
  props:['active'],
  methods:{
    toLoginValide(item){
      if(item.id==7||item.id==8){
        if(Cookies.get('userInfo')){
          if(!JSON.parse(Cookies.get('userInfo')).token){
            this.$message.success('请先登录再操作')
            // setTimeout(()=>{
              this.$router.push('/login')
            // },1000)
          }else{
            // getMe().then(res=>{
            //   if(res.data.code=='0'){
            //   }else if(res.data.code=='403'){
            //     this.$message.success('请先登录再操作')
            //     // setTimeout(()=>{
            //       this.$router.push('/login')
            //     // },1000)
            //     Cookies.remove('userInfo')
            //     Cookies.remove('userAllInfo')
            //   }else{
            //     this.$message.success('请先登录再操作')
            //     // setTimeout(()=>{
            //       this.$router.push('/login')
            //     // },1000)
            //     Cookies.remove('userInfo')
            //     Cookies.remove('userAllInfo')
            //   }
            // })
          }
        }else{
          this.$message.success('请先登录再操作')
          // setTimeout(()=>{
            this.$router.push('/login')
          // },1000)
        }
      }
    },
    toLoginValide1(item,item1,index1){
      if(item.id==7){
        if(Cookies.get('userInfo')){
          if(!JSON.parse(Cookies.get('userInfo')).token){
            this.$message.success('请先登录再操作')
            // setTimeout(()=>{
              this.$router.push('/login')
            // },1000)
          }else{
            // getMe().then(res=>{
            //   if(res.data.code=='0'){
                this.$router.push({'name': item1.src , query:{id:parseInt(index1)+1,time:(new Date()).getTime()}})
            //   }else if(res.data.code=='403'){
            //     Cookies.remove('userInfo')
            //     Cookies.remove('userAllInfo')
            //     this.$message.success('请先登录再操作')
            //     // setTimeout(()=>{
            //       this.$router.push('/login')
            //     // },1000)
            //   }else{
            //     Cookies.remove('userInfo')
            //     Cookies.remove('userAllInfo')
            //     this.$message.success('请先登录再操作')
            //     // setTimeout(()=>{
            //       this.$router.push('/login')
            //     // },1000)
            //   }
            // })
          }
        }else{
          this.$message.success('请先登录再操作')
          // setTimeout(()=>{
            this.$router.push('/login')
          // },1000)
        }
      }else{
        this.$router.push({'name': item1.src , query:{id:parseInt(index1)+1,time:(new Date()).getTime()}})
      }
    },
    tosearchShow(){
      this.searchShow=!this.searchShow
      this.searchName=''
    },
    logout(){
      logout().then(res=>{
        if(res.data.code==0){
          this.zhShow=1
          // localStorage.clear();
          Cookies.remove('userInfo')
          Cookies.remove('userAllInfo')
          Object.keys(localStorage).forEach(item => {
            if(item!='count'){
              localStorage.removeItem(item)
            }
          });
          if(this.zhShow==1){
            this.$router.push({name:'Home'})
          }
        }
      })
    },
    toSearch(){
      this.$router.push({name:'Search',query:{name:this.searchName}})
    },
    pClick(item){

    },
    change(val){
      // 中文
      if(val==0){
          // this.lang="zh";
          // localStorage.setItem("locale",this.lang)
          // this.$i18n.locale = this.lang;
      // 英文
        }else if(val==1){
          var p = window.location.protocol;
          var a = document.createElement("a");
          a.setAttribute("href", `https://api.qzkjg.org.cn`);
          a.setAttribute("target", "_blank");
          a.click();
          document.getElementsByTagName("body")[0].appendChild(a);

          // this.lang='en';
          // localStorage.setItem("locale",this.lang)
          // this.$i18n.locale = this.lang;
      //日文
        }else if(val==2){
          // this.lang="ja";
          // localStorage.setItem("locale",this.lang)
          // this.$i18n.locale = this.lang;
      //韩文
        }else if(val==3){
          // this.lang="ko";
          // localStorage.setItem("locale",this.lang)
          // this.$i18n.locale = this.lang;
        }
    },
    toLogin(id){
      if(id==1){
        this.$router.push({name:'Register'})
      }else{
        this.$router.push({name:'Login'})
      }
    },
    // beforeunloadHandler(e) {    //根据事件进行操作进行操作
    //   getMe().then(res=>{
    //     if(res.data.code=='0'){
    //       this.zhShow=0
    //     }else if(res.data.code=='403'){
    //       this.zhShow=1
    //       localStorage.removeItem('userInfo')
    //       localStorage.removeItem('userAllInfo')
    //     }else{
    //       this.zhShow=1
    //       localStorage.removeItem('userInfo')
    //       localStorage.removeItem('userAllInfo')
    //     }
    //   })
    // },
  },
  // destroyed () {  //进行监听销毁
  //     window.removeEventListener('beforeunload', e =>this.beforeunloadHandler(e))
  // },
  mounted(){
    if(Cookies.get('userInfo')){
      if(!JSON.parse(Cookies.get('userInfo')).token){
        this.zhShow=1
      }else{
        this.zhShow=0
        // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))   //监听页面刷新触发事件
      }
    }else{
      this.zhShow=1
    }
    this.route=this.$route.path
  },
  created(){
    if(Cookies.get('userAllInfo')){
      this.userAllInfo=JSON.parse(Cookies.get('userAllInfo'))
    }
  },
  watch:{
    $route: {
       handler: function(val, oldVal){

       },
       // 深度观察监听
       deep: true
    },
    zhShow:{
      handler(val,oldVal){
        this.zhShow=val
      },
      deep:true
    }
  }
};
</script>
<style>
  .menuSelect .popper__arrow{
     background: transparent!important;
     border-bottom-color: #999!important;
     transform: translate(50%, 0);
  }
  .menuSelect .popper__arrow::after{
     border-bottom-color: #999!important;
  }
  .menuSelect.el-select-dropdown{
      border: none;
      background-color: rgba(255,255,255,.3)!important;
      color: #fff
  }
  .menuSelect .el-input__inner{
      color:#eee;
      border-color: rgba(255,255,255,.1);
      background-color: rgba(255,255,255,.1);
  }
  .menuSelect .el-select .el-input.is-focus .el-input__inner{
      border-color: rgba(255,255,255,.1);
      background-color: rgba(255,255,255,.1);
      color:rgba(255,255,255,.1);
  }
  .menuSelect .el-select-dropdown__item{
      color: #fff;
  }
  .menuSelect .el-select-dropdown__item:hover{
      color:rgba(255,255,255,1);
      background-color: rgba(255,255,255,0);
  }
  .menuSelect .el-select-dropdown__list{
    /* background-color: rgba(255,255,255,.1)!important; */
    color: #fff;
  }
  .menuSelect .el-select-dropdown__item{
    /* background-color: rgba(255,255,255,.1)!important; */
    color:rgba(255,255,255,.6);
     background-color: rgba(255,255,255,0);
     text-align: center;
  }

</style>
<style lang="less" scoped>
  .menuw{
    width: 100vw;
    height: 1.125rem;
    padding:0 1.1375rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background-image: url('../assets/image/bannerImg.png');
    background-size: 100% 100%;
  }
  .menu{
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .menu1{
    flex: 0 0 1.4625rem;
    width: 1.4625rem;
    height: 0.275rem;
    img{
      width: 1.4625rem;
      height: 0.275rem;
    }
  }
  .menu2{
    flex: 1;
    height: 1.125rem;
    line-height: 1.125rem;
  }
  .menu3t{
    flex: 0 0 1.25rem;
    display: flex;
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    opacity: 0.8;
    z-index: 3000;
  }
  .menu3{
    flex: 0 0 1.625rem;
    display: flex;
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    opacity: 0.8;
    .menu31{
      display: flex;
      align-items: center;
      position: relative;
      // flex: 1;
      text-align: center;
      margin-right: 0.0875*2rem;
    }
    .menu31:after{
        position: absolute;
        right: -0.0875rem;
        // margin-top: 0.0375rem;
        height:calc(100% - 0.075rem);
        width: 1px;
        height: 0.2rem;
        background: #fff;
        content:'';
    }
    .menu32{
      // flex: 1;
      text-align: center;
    }
  }
  .menu4{
    flex:0 0 0.3rem;
    font-size: 0.225rem;
    color: #FFFFFF;
    // opacity: 0.8;
    text-align: right;
    /deep/ .el-input__inner{
      width: 3.7375rem;
      height: 0.625rem;
    }
    /deep/ .el-input-group__append{
      width: 0.95rem;
      height: 0.625rem;
      border: none;
      padding: 0;
      background: #EE564F;
      border-radius: 0px 6px 6px 0px;
      .el-button{
        width: 0.95rem;
        height: 0.625rem;
        border: none;
        padding: 0;
        background: #EE564F;
        border-radius: 0px 6px 6px 0px;
        font-size: 0.225rem;
        color: #FFFFFF;
      }
      .el-button:active{
        box-shadow: inset 0px 0px 1px 1px #b5413b;
      }
    }
  }
  .menu5{
    flex: 0 0 2rem;
    text-align: right;
    width: 1.5rem;
    .el-input__inner::placeholder{
      font-size: 0.15rem;
    }
    .el-select{
      width: 1.4625rem;
      height: 0.5rem;
      background: rgba(255,255,255,.1);
      border-radius: 8px;
    }
    /deep/ .el-input__inner{
      background: rgba(255,255,255,.1);
      color: #fff;
      height: 0.5rem;
    }
    /deep/ .el-input__icon{
      line-height: 0.5rem;
    }

  }
  .menu-container {
    font-size: 0.1875rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #f2f2f2;
    // line-height: 0.3rem;
    width: 100%;
    height: 100%;
    padding-left: 0.25rem;
    box-sizing: border-box;
    display: flex;
    // justify-content: space-evenly;
    position: relative;
    box-sizing: border-box;
    li {
      position: relative;
      list-style: none;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      // line-height: 0.4875rem
      z-index: 10;
      height: 100%;
      width: 1.6375rem;
      display: inline-block;
      box-sizing: border-box;
       // visibility: visible;
      // &:hover a + .ul-child >ul> .li-child {
      //   visibility: visible;
      //   transition: all 0.25s linear;
      //   height: 0.625rem;
      //   line-height: 0.625rem;
      //   // animation: moveFromTop 0.3s ease-in-out
      // }
      &:hover a + .ul-child {
        visibility: visible;
        transition: all 0.25s linear;
        // height: 0.625rem;
        line-height: 0.625rem;
        // animation: moveFromTop 0.3s ease-in-out
      }
      a {
        text-decoration: none;
        outline: none;
        font-size: 0.215rem;
        color: rgba(255,255,255,.7);
        // height: 0.5rem;
        // line-height: 0.5rem;
        box-sizing: border-box;
        word-break: break-all;
        // border-bottom: 4px solid transparent;

        &:hover + .ul-child > .li-child:nth-child(1) {
          // border-top: 4px solid red;
        }
      }
      .ul-child {
        position: absolute;
        width: 1.6375rem;
        // background: #cccccc;
        // top: 0.375rem;
        top: 1.125rem;
        // height: 1.25rem;
        justify-content: center;
        // padding-top: 1.125rem;
        visibility: hidden;
        // visibility:visible;
        box-shadow: 0 0 0.0625rem #00000020!important;
        box-sizing: border-box;
        .li-child {
          width: 1.6375rem;
          height: 0.625rem;
          line-height: 0.625rem;
          display:flex;
          align-items: center;
          text-align: center;
          cursor: pointer;
          padding:0.1rem 0.05rem;
          // border-top: 0.05rem solid transparent;
          box-sizing: border-box;
          background: #fff;
          color: #000;
          // border-bottom: 1px solid rgb(207, 21, 45);
          // border-bottom: 1px solid transparent;
          a {
            color: #000;
          }
          &::after {
            // content: url("../assets/home/arrow.png");
            padding: 0 0 0.05rem 0.175rem;
          }
          //   max-height: 0;
          &:not(:last-child) {
            // color:red;
            border-bottom: 1px solid white;
          }
          &:last-child {
            border-bottom-left-radius: 0.0625rem;
            border-bottom-right-radius: 0.0625rem;
          }
          &:hover {
            color: #e7534d;
            background: #FFF;
            // border-bottom: 1px solid #FFF;
            a {
              color: #e7534d;
            }
            &::after {
              // content: url("../assets/home/company.png");
              padding: 0 0 0.05rem 0.175rem;
            }
          }

        }
      }
    }
    li:first-child{
      width: 1.3rem;
    }
    li:hover {
      a{
        color: #CE0E2B;
      }
    }
  }
  a.ulAsty{
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  a.ulAstyActive{
    color: rgb(255,255,255)!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue